import { Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUserNameById } from "../api";
import { usernames } from "../pages/DiscoverPage";
import { Announcement, Comment } from "../types/Announcement";


interface DialogProps {
    announcement?: Announcement;
    open: boolean;
    onClose: (value?: string) => void;
}
export default function AnnouncementDialog (props: DialogProps) {

    const { onClose, open, announcement } = props;
    const [comments, setComments] = useState<Comment[]>([]);
    const [usernames, setUsernames] = useState<{id: string, name: string}[]>([])
    const {t} = useTranslation();
    useEffect(() => {
        console.log(announcement?.comments)
        if (announcement?.comments) {
            setComments(announcement.comments)
            getUserNames(announcement.comments)
        }
    }, [announcement]);

    const handleCancel = () => onClose();

    const getUserNames = (comments: Comment[]) => {
        let names: {id: string, name: string}[] = [];
        comments.forEach(async comment => {
            let name = await getUserNameById(comment.createdBy);
            names.push({id: comment.createdBy, name: name?? ""})
        })
        setUsernames(names)
    }
    // const handleSubmit = () => onClose(value);

    return (
        <Dialog
            sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
            open={open}
            maxWidth="xs"
        >
            <DialogTitle>
                {announcement?.title?? "Empty Announcement"}
            </DialogTitle>
            <DialogContent>
                {announcement?.message?? ""}
                <Divider sx={{ marginY: 2 }} />
                {
                    comments && comments.map(comment =>
                        <Card key={comment.announcementId} sx={{ boxShadow: 4, marginBottom: 1}}>
                            <CardHeader 
                                sx={{ padding: 1 }} 
                                title={
                                    <Typography sx={{ fontSize: 16 }}>
                                        {usernames.find(user => user.id === comment.createdBy)?.name?? ""}
                                    </Typography>
                                } 
                            />
                            <Divider />
                            <CardContent sx={{ padding: 1, ".MuiCardContent-root": {":last-child": {paddingBottom: 0} }}} >
                                <Typography sx={{ fontSize: 14 }} component="div">
                                    {comment.message}
                                </Typography>
                            </CardContent>
                        </Card>
                    )
                }
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel}>
                    {t("butt.close")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}